import {withSystem} from '@packages/systems/wfdl';

import {TEnum} from '@packages/systems/wfdl-ast';

export const renderMode = withSystem(
  {label: 'Render', defaultValue: 'svg', isLocalizable: true},
  TEnum({
    svg: 'SVG',
    canvas: 'Canvas',
  })
);
